import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { showUserAlert } from "actions/alertActions";

function withAlert(ChildComponent) {
  return class extends Component {
    render() {
      return (
        <ChildComponent showAlert={this.props.showUserAlert} {...this.props} />
      );
    }
  };
}

const mapDispatchToProps = {
  showUserAlert: showUserAlert,
};

export default compose(connect(null, mapDispatchToProps), withAlert);
